export const splitArrayInHalf = <T>(arr: T[] = []): [T[], T[]] => {
  const half = Math.ceil(arr.length / 2);

  return [arr.slice(0, half), arr.slice(half)];
};

export const findMostCommonKey = (arr: string[]): string => {
  const keyCount = arr
    .map((item) => item.split('_')[0])
    .reduce((countMap, firstPart) => {
      countMap.set(firstPart, (countMap.get(firstPart) || 0) + 1);

      return countMap;
    }, new Map<string, number>());

  return [...keyCount.entries()]
    .reduce((maxPart, [firstPart, count]) => {
      if (count > maxPart[1]) {
        return [firstPart, count];
      }

      return maxPart;
    }, ['', 0])[0];
};
